module.exports = __webpack_public_path__ + "static/img/default_yegw_avator.7ebb3088.png";